module.exports = __webpack_public_path__ + "img/new_13.7fad95ad.jpg";